import apinode from '../../apinode'

class OrcamentosService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll() {
    const response = await apinode.get(`/orcamentos/${this.idconta}`)

    return response.data
  }

  async getEstimativeToPrint(idOrcamento) {
    const response = await apinode.get(
      `/orcamentos/${this.idconta}/${idOrcamento}/print`,
    )

    return response.data
  }

  async exportToSales(idOrcamento) {
    const response = await apinode.post(
      `/orcamentos/${this.idconta}/export/sales/${idOrcamento}`,
    )

    return response.data.message
  }

  async clone(idOrcamento) {
    const response = await apinode.put(
      `/orcamentos/clone/${idOrcamento}/${this.idconta}`,
    )

    return response.data.message
  }

  async delete(idOrcamento) {
    await apinode.delete(`/orcamentos/${idOrcamento}/${this.idconta}`)
  }
}

export default new OrcamentosService()
